import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

import type { IAccount } from '../accounts.types';

export const accountAPi = createApi({
  reducerPath: 'accountApi',
  baseQuery,
  endpoints: (builder) => ({
    getAccountsList: builder.mutation({
      query: (filterQuery) => ({
        url: 'company/list',
        method: 'POST',
        body: filterQuery,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { company?: { list?: IAccount[]; total?: number } };
      }) => ({
        list: response?.data?.company?.list ?? [],
        total: response?.data?.company?.total ?? 0,
      }),
    }),
    createAccount: builder.mutation<IAccount, Partial<IAccount>>({
      query: (newAccount) => ({
        url: 'company/add',
        method: 'POST',
        body: newAccount,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { company: IAccount };
        success: boolean;
      }): IAccount =>
        response.success && response.data?.company ? response.data.company : ({} as IAccount),
    }),
    updateAccount: builder.mutation<IAccount, { id: string; updates: Partial<IAccount> }>({
      query: ({ id, updates }) => ({
        url: `company/update`,
        method: 'POST',
        body: { id, ...updates },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    filterAccount: builder.mutation({
      query: (filterQuery) => ({
        url: `company/list`,
        method: 'POST',
        body: filterQuery,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { company?: { list?: IAccount[]; total?: number } };
      }) => ({
        list: response?.data?.company?.list ?? [],
        total: response?.data?.company?.total ?? 0,
      }),
    }),
    getAccountDtl: builder.mutation({
      query: (id: string) => ({
        url: 'company/details',
        method: 'POST',
        body: { id },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    deleteAccounts: builder.mutation({
      query: (ids: string[]) => ({
        url: 'company/delete',
        method: 'POST',
        body: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    importAccount: builder.mutation({
      query: (filePath) => ({
        url: 'company/import',
        method: 'POST',
        body: filePath,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    exportAccount: builder.mutation({
      query: (filter) => ({
        url: 'company/export',
        method: 'POST',
        body: filter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useGetAccountsListMutation,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useFilterAccountMutation,
  useGetAccountDtlMutation,
  useDeleteAccountsMutation,
  useExportAccountMutation,
  useImportAccountMutation,
} = accountAPi;
